var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 10,
    viewBox: "0 0 80 10",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10c20 0 33-4.5 40-10v10H0zM80 10C60 10 47 5.5 40 0v10h40z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDgwIDEwIiBmaWxsPSJub25lIj4KICAgIDxwYXRoIGQ9Ik04LjA4NDAzZS0wNyAxMEMyMCAxMCAzMyA1LjUgNDAgLTMuNDk2OTFlLTA2TDQwIDEwTDIwIDEwTDguMDg0MDNlLTA3IDEwWiIgZmlsbD0iY3VycmVudENvbG9yIiAvPgogICAgPHBhdGggZD0iTTgwIDEwQzYwIDEwIDQ3IDUuNSA0MCAzLjQ5NjkxZS0wNkw0MCAxMEw2MCAxMEw4MCAxMFoiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz4KPC9zdmc+";
export { SvgArrowCenter as ReactComponent };